"use strict";

import { lcvOrdersConstants } from "../_constants/lcvOrders.constants";

export const lcvOrdersPreviewImportRequest = (payload) => {
     return {
          type: lcvOrdersConstants.LCV_ORDERS_PREVIEW_IMPORT_REQUEST,
          payload,
     };
};

export const lcvOrdersPreviewImportComplete = (payload) => {
     return {
          type: lcvOrdersConstants.LCV_ORDERS_PREVIEW_IMPORT_COMPLETE,
          payload,
     };
};

export const lcvOrdersImportRequest = (payload) => {
     return {
          type: lcvOrdersConstants.LCV_ORDERS_IMPORT_REQUEST,
          payload,
     };
};

export const lcvOrdersImportComplete = (payload) => {
     return {
          type: lcvOrdersConstants.LCV_ORDERS_IMPORT_COMPLETE,
          payload,
     };
};

export const lcvOrdersClearImport = () => {
     return {
          type: lcvOrdersConstants.LCV_ORDERS_CLEAR_IMPORT,
     };
};

export const lcvOrdersGetImportHistoryRequest = (payload) => {
     return {
          type: lcvOrdersConstants.LCV_ORDERS_GET_IMPORT_HISTORY_REQUEST,
          payload,
     };
};

export const lcvOrdersGetImportHistoryComplete = (payload) => {
     return {
          type: lcvOrdersConstants.LCV_ORDERS_GET_IMPORT_HISTORY_COMPLETE,
          payload,
     };
};
